import React from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as GatewayTimeoutImage } from 'assets/svg/500-internal-server.svg'
import { ReactComponent as FixtabLogoWithTextImage } from 'assets/svg/fixtab-logo-with-text.svg'

import { currentVersion } from 'helpers/common'
import { handleTryAgain } from './management'

export const Error500Container = (): JSX.Element => {
  const { t } = useTranslation(['common', 'error'])

  return (
    <>
      <div className='con__error'>
        <div className='con__error__header'>
          <FixtabLogoWithTextImage />
        </div>

        <div className='con__error__body'>
          <GatewayTimeoutImage />

          <span className='con__error__title'>
            {t('error:internalServerError.title')}
          </span>

          <span className='con__error__content'>
            {t('error:internalServerError.content')}
          </span>

          <button className='con__error__btn' onClick={handleTryAgain}>
            <span>{t('common:tryAgain.label')}</span>
          </button>
        </div>

        <div className='con__error__footer'>
          <span>
            {t('common:version.label')} {currentVersion}
          </span>
        </div>
      </div>
    </>
  )
}
